import React from 'react';
import ErrorBoundary from '@atlassian/jira-error-boundary/src/ErrorBoundary.tsx';
import ReportErrors from '@atlassian/jira-errors-handling/src/utils/reporting-error-boundary.tsx';
import { PACKAGE_NAME, TEAM_NAME } from './common/constants.tsx';

const RecommendPremiumToStandardModalConditional = importCond<
	typeof import('./index.tsx'),
	typeof import('./async.tsx')
>('improve_bundle_loading_for_premium_to_standard', './index.tsx', './async.tsx');

export const RecommendPremiumToStandardModal = () => {
	return (
		<ErrorBoundary id="recommend-premium-to-standard-modal-async" packageName={PACKAGE_NAME}>
			<ReportErrors
				teamName={TEAM_NAME}
				id="recommend-premium-to-standard-modal-async"
				packageName={PACKAGE_NAME}
			>
				<RecommendPremiumToStandardModalConditional />
			</ReportErrors>
		</ErrorBoundary>
	);
};
